var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("OutputTimeSeriesToolbar", {
        attrs: {
          settings: _vm.toolbarSettings,
          dates: _vm.dates,
          "resources-items": _vm.resourcesItems,
          page: "pf",
          loading: _vm.loading,
        },
        on: {
          "update:settings": _vm.updateToolbarSettings,
          "update:dates": _vm.updateDates,
        },
      }),
      !_vm.loading.value
        ? _c(
            "div",
            [
              _vm.deprecationMessage
                ? _c(
                    "v-alert",
                    { staticClass: "mb-4", attrs: { type: "warning" } },
                    [_vm._v(" " + _vm._s(_vm.deprecationMessage) + " ")]
                  )
                : _vm.showDateFilterAlert
                ? _c(
                    "v-alert",
                    { staticClass: "mb-4", attrs: { type: "warning" } },
                    [
                      _vm._v(
                        " No data found for selected date range. Showing data for " +
                          _vm._s(_vm.fallbackDateDisplay) +
                          " instead. "
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "v-card",
                { staticClass: "mb-4" },
                [
                  _c("v-card-title", [_vm._v("Power Flow Dashboard")]),
                  _c("v-card-text", [
                    _vm.toolbarSettings.viewMode === "contingency"
                      ? _c(
                          "div",
                          [
                            _c("h2", { staticClass: "mb-4" }, [
                              _vm._v("Contingency Analysis"),
                            ]),
                            _c("v-data-table", {
                              staticClass: "elevation-1",
                              attrs: {
                                headers: _vm.contingencyHeaders,
                                items: _vm.contingencyData,
                                "items-per-page": 20,
                                dense: "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "item.maxVm",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatTableValue(item.maxVm)
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.minVm",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatTableValue(item.minVm)
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.maxLoading",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatTableValue(
                                                item.maxLoading
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.loss",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formatTableValue(item.loss)
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1203894985
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm.toolbarSettings.viewMode === "violationReport"
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "mb-6" },
                            [
                              _c("PFViolationReport", {
                                attrs: {
                                  upperLimit: _vm.voltageUpperLimit,
                                  lowerLimit: _vm.voltageLowerLimit,
                                  data: _vm.nodeViolationTableData,
                                  units: "p.u.",
                                  title: "Bus Voltage Violations",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "mb-6" },
                            [
                              _c("PFViolationReport", {
                                attrs: {
                                  upperLimit: _vm.lineLoadingLimit,
                                  data: _vm.lineViolationTableData,
                                  units: "%",
                                  title: "Line Loading Violations",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.resourcesItems.trafo.length > 0
                            ? _c(
                                "div",
                                { staticClass: "mb-6" },
                                [
                                  _c("PFViolationReport", {
                                    attrs: {
                                      upperLimit: _vm.trafoLoadingLimit,
                                      data: _vm.trafoViolationTableData,
                                      units: "%",
                                      title: "Transformer Loading Violations",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.resourcesItems.gen.length > 0
                            ? _c(
                                "div",
                                { staticClass: "mb-6" },
                                [
                                  _c("PFViolationReport", {
                                    attrs: {
                                      lowerLimit: _vm.genPowerFactorLimit,
                                      data: _vm.genViolationTableData,
                                      units: "",
                                      title:
                                        "Generator Power Factor Violations",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ])
                      : _vm.toolbarSettings.pfTimeSeriesOutputType === "tabular"
                      ? _c("div", [
                          _vm.resourcesItems.bus.length > 0
                            ? _c(
                                "div",
                                { staticClass: "mb-8" },
                                [
                                  _c("h2", { staticClass: "mb-4" }, [
                                    _vm._v("Bus Tables"),
                                  ]),
                                  _c(
                                    "v-tabs",
                                    {
                                      staticClass: "mb-4",
                                      model: {
                                        value: _vm.busActiveTab,
                                        callback: function ($$v) {
                                          _vm.busActiveTab = $$v
                                        },
                                        expression: "busActiveTab",
                                      },
                                    },
                                    _vm._l(_vm.busMetrics, function (metric) {
                                      return _c("v-tab", { key: metric.key }, [
                                        _vm._v(" " + _vm._s(metric.name) + " "),
                                      ])
                                    }),
                                    1
                                  ),
                                  _c(
                                    "v-tabs-items",
                                    {
                                      model: {
                                        value: _vm.busActiveTab,
                                        callback: function ($$v) {
                                          _vm.busActiveTab = $$v
                                        },
                                        expression: "busActiveTab",
                                      },
                                    },
                                    _vm._l(_vm.busMetrics, function (metric) {
                                      return _c(
                                        "v-tab-item",
                                        { key: metric.key },
                                        [
                                          _c("v-data-table", {
                                            staticClass: "elevation-1",
                                            attrs: {
                                              headers: _vm.getBusTableHeaders(),
                                              items: _vm.getBusTableData(
                                                metric.key
                                              ),
                                              "items-per-page": 20,
                                              dense: "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "item",
                                                  fn: function (ref) {
                                                    var item = ref.item
                                                    return [
                                                      _c(
                                                        "tr",
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.busName
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._l(
                                                            item.values,
                                                            function (
                                                              timeValue
                                                            ) {
                                                              return _c(
                                                                "td",
                                                                {
                                                                  key: timeValue.time,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.formatTableValue(
                                                                          timeValue.value
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.resourcesItems.line.length > 0
                            ? _c(
                                "div",
                                { staticClass: "mb-8" },
                                [
                                  _c("h2", { staticClass: "mb-4" }, [
                                    _vm._v("Line Tables"),
                                  ]),
                                  _c(
                                    "v-tabs",
                                    {
                                      staticClass: "mb-4",
                                      model: {
                                        value: _vm.lineActiveTab,
                                        callback: function ($$v) {
                                          _vm.lineActiveTab = $$v
                                        },
                                        expression: "lineActiveTab",
                                      },
                                    },
                                    _vm._l(_vm.lineMetrics, function (metric) {
                                      return _c("v-tab", { key: metric.key }, [
                                        _vm._v(" " + _vm._s(metric.name) + " "),
                                      ])
                                    }),
                                    1
                                  ),
                                  _c(
                                    "v-tabs-items",
                                    {
                                      model: {
                                        value: _vm.lineActiveTab,
                                        callback: function ($$v) {
                                          _vm.lineActiveTab = $$v
                                        },
                                        expression: "lineActiveTab",
                                      },
                                    },
                                    _vm._l(_vm.lineMetrics, function (metric) {
                                      return _c(
                                        "v-tab-item",
                                        { key: metric.key },
                                        [
                                          _c("v-data-table", {
                                            staticClass: "elevation-1",
                                            attrs: {
                                              headers:
                                                _vm.getLineTableHeaders(),
                                              items: _vm.getLineTableData(
                                                metric.key
                                              ),
                                              "items-per-page": 20,
                                              dense: "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "item",
                                                  fn: function (ref) {
                                                    var item = ref.item
                                                    return [
                                                      _c(
                                                        "tr",
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.lineName
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._l(
                                                            item.values,
                                                            function (
                                                              timeValue
                                                            ) {
                                                              return _c(
                                                                "td",
                                                                {
                                                                  key: timeValue.time,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.formatTableValue(
                                                                          timeValue.value
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.resourcesItems.trafo.length > 0
                            ? _c(
                                "div",
                                { staticClass: "mb-8" },
                                [
                                  _c("h2", { staticClass: "mb-4" }, [
                                    _vm._v("2-Winding Transformer Tables"),
                                  ]),
                                  _c(
                                    "v-tabs",
                                    {
                                      staticClass: "mb-4",
                                      model: {
                                        value: _vm.trafoActiveTab,
                                        callback: function ($$v) {
                                          _vm.trafoActiveTab = $$v
                                        },
                                        expression: "trafoActiveTab",
                                      },
                                    },
                                    _vm._l(_vm.trafoMetrics, function (metric) {
                                      return _c("v-tab", { key: metric.key }, [
                                        _vm._v(" " + _vm._s(metric.name) + " "),
                                      ])
                                    }),
                                    1
                                  ),
                                  _c(
                                    "v-tabs-items",
                                    {
                                      model: {
                                        value: _vm.trafoActiveTab,
                                        callback: function ($$v) {
                                          _vm.trafoActiveTab = $$v
                                        },
                                        expression: "trafoActiveTab",
                                      },
                                    },
                                    _vm._l(_vm.trafoMetrics, function (metric) {
                                      return _c(
                                        "v-tab-item",
                                        { key: metric.key },
                                        [
                                          _c("v-data-table", {
                                            staticClass: "elevation-1",
                                            attrs: {
                                              headers:
                                                _vm.getTrafoTableHeaders(),
                                              items: _vm.getTrafoTableData(
                                                metric.key
                                              ),
                                              "items-per-page": 20,
                                              dense: "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "item",
                                                  fn: function (ref) {
                                                    var item = ref.item
                                                    return [
                                                      _c(
                                                        "tr",
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.trafoName
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._l(
                                                            item.values,
                                                            function (
                                                              timeValue
                                                            ) {
                                                              return _c(
                                                                "td",
                                                                {
                                                                  key: timeValue.time,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.formatTableValue(
                                                                          timeValue.value
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.resourcesItems.trafo3w.length > 0
                            ? _c(
                                "div",
                                { staticClass: "mb-8" },
                                [
                                  _c("h2", { staticClass: "mb-4" }, [
                                    _vm._v("3-Winding Transformer Tables"),
                                  ]),
                                  _c(
                                    "v-tabs",
                                    {
                                      staticClass: "mb-4",
                                      model: {
                                        value: _vm.trafo3wActiveTab,
                                        callback: function ($$v) {
                                          _vm.trafo3wActiveTab = $$v
                                        },
                                        expression: "trafo3wActiveTab",
                                      },
                                    },
                                    _vm._l(
                                      _vm.trafo3wMetrics,
                                      function (metric) {
                                        return _c(
                                          "v-tab",
                                          { key: metric.key },
                                          [
                                            _vm._v(
                                              " " + _vm._s(metric.name) + " "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                  _c(
                                    "v-tabs-items",
                                    {
                                      model: {
                                        value: _vm.trafo3wActiveTab,
                                        callback: function ($$v) {
                                          _vm.trafo3wActiveTab = $$v
                                        },
                                        expression: "trafo3wActiveTab",
                                      },
                                    },
                                    _vm._l(
                                      _vm.trafo3wMetrics,
                                      function (metric) {
                                        return _c(
                                          "v-tab-item",
                                          { key: metric.key },
                                          [
                                            _c("v-data-table", {
                                              staticClass: "elevation-1",
                                              attrs: {
                                                headers:
                                                  _vm.getTrafo3wTableHeaders(),
                                                items: _vm.getTrafo3wTableData(
                                                  metric.key
                                                ),
                                                "items-per-page": 20,
                                                dense: "",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "item",
                                                    fn: function (ref) {
                                                      var item = ref.item
                                                      return [
                                                        _c(
                                                          "tr",
                                                          [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "font-weight-bold",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.trafo3wName
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._l(
                                                              item.values,
                                                              function (
                                                                timeValue
                                                              ) {
                                                                return _c(
                                                                  "td",
                                                                  {
                                                                    key: timeValue.time,
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.formatTableValue(
                                                                            timeValue.value
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.resourcesItems.load.length > 0
                            ? _c(
                                "div",
                                { staticClass: "mb-8" },
                                [
                                  _c("h2", { staticClass: "mb-4" }, [
                                    _vm._v("Load Tables"),
                                  ]),
                                  _c(
                                    "v-tabs",
                                    {
                                      staticClass: "mb-4",
                                      model: {
                                        value: _vm.loadActiveTab,
                                        callback: function ($$v) {
                                          _vm.loadActiveTab = $$v
                                        },
                                        expression: "loadActiveTab",
                                      },
                                    },
                                    _vm._l(_vm.loadMetrics, function (metric) {
                                      return _c("v-tab", { key: metric.key }, [
                                        _vm._v(" " + _vm._s(metric.name) + " "),
                                      ])
                                    }),
                                    1
                                  ),
                                  _c(
                                    "v-tabs-items",
                                    {
                                      model: {
                                        value: _vm.loadActiveTab,
                                        callback: function ($$v) {
                                          _vm.loadActiveTab = $$v
                                        },
                                        expression: "loadActiveTab",
                                      },
                                    },
                                    _vm._l(_vm.loadMetrics, function (metric) {
                                      return _c(
                                        "v-tab-item",
                                        { key: metric.key },
                                        [
                                          _c("v-data-table", {
                                            staticClass: "elevation-1",
                                            attrs: {
                                              headers:
                                                _vm.getLoadTableHeaders(),
                                              items: _vm.getLoadTableData(
                                                metric.key
                                              ),
                                              "items-per-page": 20,
                                              dense: "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "item",
                                                  fn: function (ref) {
                                                    var item = ref.item
                                                    return [
                                                      _c(
                                                        "tr",
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.loadName
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._l(
                                                            item.values,
                                                            function (
                                                              timeValue
                                                            ) {
                                                              return _c(
                                                                "td",
                                                                {
                                                                  key: timeValue.time,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.formatTableValue(
                                                                          timeValue.value
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.resourcesItems.gen.length > 0
                            ? _c(
                                "div",
                                { staticClass: "mb-8" },
                                [
                                  _c("h2", { staticClass: "mb-4" }, [
                                    _vm._v("Generator Tables"),
                                  ]),
                                  _c(
                                    "v-tabs",
                                    {
                                      staticClass: "mb-4",
                                      model: {
                                        value: _vm.genActiveTab,
                                        callback: function ($$v) {
                                          _vm.genActiveTab = $$v
                                        },
                                        expression: "genActiveTab",
                                      },
                                    },
                                    _vm._l(_vm.genMetrics, function (metric) {
                                      return _c("v-tab", { key: metric.key }, [
                                        _vm._v(" " + _vm._s(metric.name) + " "),
                                      ])
                                    }),
                                    1
                                  ),
                                  _c(
                                    "v-tabs-items",
                                    {
                                      model: {
                                        value: _vm.genActiveTab,
                                        callback: function ($$v) {
                                          _vm.genActiveTab = $$v
                                        },
                                        expression: "genActiveTab",
                                      },
                                    },
                                    _vm._l(_vm.genMetrics, function (metric) {
                                      return _c(
                                        "v-tab-item",
                                        { key: metric.key },
                                        [
                                          _c("v-data-table", {
                                            staticClass: "elevation-1",
                                            attrs: {
                                              headers: _vm.getGenTableHeaders(),
                                              items: _vm.getGenTableData(
                                                metric.key
                                              ),
                                              "items-per-page": 20,
                                              dense: "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "item",
                                                  fn: function (ref) {
                                                    var item = ref.item
                                                    return [
                                                      _c(
                                                        "tr",
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.genName
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._l(
                                                            item.values,
                                                            function (
                                                              timeValue
                                                            ) {
                                                              return _c(
                                                                "td",
                                                                {
                                                                  key: timeValue.time,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.formatTableValue(
                                                                          timeValue.value
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.resourcesItems.sgen.length > 0
                            ? _c(
                                "div",
                                { staticClass: "mb-8" },
                                [
                                  _c("h2", { staticClass: "mb-4" }, [
                                    _vm._v("Static Generator Tables"),
                                  ]),
                                  _c(
                                    "v-tabs",
                                    {
                                      staticClass: "mb-4",
                                      model: {
                                        value: _vm.sgenActiveTab,
                                        callback: function ($$v) {
                                          _vm.sgenActiveTab = $$v
                                        },
                                        expression: "sgenActiveTab",
                                      },
                                    },
                                    _vm._l(_vm.sgenMetrics, function (metric) {
                                      return _c("v-tab", { key: metric.key }, [
                                        _vm._v(" " + _vm._s(metric.name) + " "),
                                      ])
                                    }),
                                    1
                                  ),
                                  _c(
                                    "v-tabs-items",
                                    {
                                      model: {
                                        value: _vm.sgenActiveTab,
                                        callback: function ($$v) {
                                          _vm.sgenActiveTab = $$v
                                        },
                                        expression: "sgenActiveTab",
                                      },
                                    },
                                    _vm._l(_vm.sgenMetrics, function (metric) {
                                      return _c(
                                        "v-tab-item",
                                        { key: metric.key },
                                        [
                                          _c("v-data-table", {
                                            staticClass: "elevation-1",
                                            attrs: {
                                              headers:
                                                _vm.getSgenTableHeaders(),
                                              items: _vm.getSgenTableData(
                                                metric.key
                                              ),
                                              "items-per-page": 20,
                                              dense: "",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "item",
                                                  fn: function (ref) {
                                                    var item = ref.item
                                                    return [
                                                      _c(
                                                        "tr",
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "font-weight-bold",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.sgenName
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._l(
                                                            item.values,
                                                            function (
                                                              timeValue
                                                            ) {
                                                              return _c(
                                                                "td",
                                                                {
                                                                  key: timeValue.time,
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.formatTableValue(
                                                                          timeValue.value
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ])
                      : _c(
                          "div",
                          [
                            _vm.totalSelectedElements === 0
                              ? _c(
                                  "v-alert",
                                  {
                                    staticClass: "mb-4",
                                    attrs: { type: "info" },
                                  },
                                  [
                                    _vm._v(
                                      " Select elements from the toolbar above to display power flow charts "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm.toolbarSettings.bus.length > 0
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c("v-col", { attrs: { cols: "12" } }, [
                                          _c("h2", [_vm._v("Buses")]),
                                        ]),
                                        _vm._l(
                                          _vm.busMetrics.slice(0, 4),
                                          function (metric) {
                                            return _c(
                                              "v-col",
                                              {
                                                key: metric.key,
                                                attrs: { cols: "6" },
                                              },
                                              [
                                                _c("h3", [
                                                  _vm._v(_vm._s(metric.name)),
                                                ]),
                                                _c("Plotly", {
                                                  attrs: {
                                                    data: _vm.getBusMetricData(
                                                      metric.key
                                                    ),
                                                    layout:
                                                      _vm.getBusMetricLayout(
                                                        metric.label
                                                      ),
                                                    config: {
                                                      responsive: true,
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                    _vm.busMetrics.length > 4
                                      ? _c(
                                          "v-expansion-panels",
                                          { staticClass: "mt-4" },
                                          [
                                            _c(
                                              "v-expansion-panel",
                                              [
                                                _c("v-expansion-panel-header", [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Additional Bus Charts (" +
                                                        _vm._s(
                                                          _vm.busMetrics
                                                            .length - 4
                                                        ) +
                                                        " more)"
                                                    ),
                                                  ]),
                                                ]),
                                                _c(
                                                  "v-expansion-panel-content",
                                                  [
                                                    _c(
                                                      "v-row",
                                                      _vm._l(
                                                        _vm.busMetrics.slice(4),
                                                        function (metric) {
                                                          return _c(
                                                            "v-col",
                                                            {
                                                              key: metric.key,
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c("h3", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    metric.name
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("Plotly", {
                                                                attrs: {
                                                                  data: _vm.getBusMetricData(
                                                                    metric.key
                                                                  ),
                                                                  layout:
                                                                    _vm.getBusMetricLayout(
                                                                      metric.label
                                                                    ),
                                                                  config: {
                                                                    responsive: true,
                                                                  },
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.toolbarSettings.trafo.length > 0
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c("v-col", { attrs: { cols: "12" } }, [
                                          _c("h2", [
                                            _vm._v("2-Winding Transformers"),
                                          ]),
                                        ]),
                                        _vm._l(
                                          _vm.trafoMetrics.slice(0, 4),
                                          function (metric) {
                                            return _c(
                                              "v-col",
                                              {
                                                key: metric.key,
                                                attrs: { cols: "6" },
                                              },
                                              [
                                                _c("h3", [
                                                  _vm._v(_vm._s(metric.name)),
                                                ]),
                                                _c("Plotly", {
                                                  attrs: {
                                                    data: _vm.getTrafoMetricData(
                                                      metric.key
                                                    ),
                                                    layout:
                                                      _vm.getTrafoMetricLayout(
                                                        metric.label
                                                      ),
                                                    config: {
                                                      responsive: true,
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                    _vm.trafoMetrics.length > 4
                                      ? _c(
                                          "v-expansion-panels",
                                          { staticClass: "mt-4" },
                                          [
                                            _c(
                                              "v-expansion-panel",
                                              [
                                                _c("v-expansion-panel-header", [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Additional 2W Transformer Charts (" +
                                                        _vm._s(
                                                          _vm.trafoMetrics
                                                            .length - 4
                                                        ) +
                                                        " more)"
                                                    ),
                                                  ]),
                                                ]),
                                                _c(
                                                  "v-expansion-panel-content",
                                                  [
                                                    _c(
                                                      "v-row",
                                                      _vm._l(
                                                        _vm.trafoMetrics.slice(
                                                          4
                                                        ),
                                                        function (metric) {
                                                          return _c(
                                                            "v-col",
                                                            {
                                                              key: metric.key,
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c("h3", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    metric.name
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("Plotly", {
                                                                attrs: {
                                                                  data: _vm.getTrafoMetricData(
                                                                    metric.key
                                                                  ),
                                                                  layout:
                                                                    _vm.getTrafoMetricLayout(
                                                                      metric.label
                                                                    ),
                                                                  config: {
                                                                    responsive: true,
                                                                  },
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.toolbarSettings.line.length > 0
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c("v-col", { attrs: { cols: "12" } }, [
                                          _c("h2", [_vm._v("Lines")]),
                                        ]),
                                        _vm._l(
                                          _vm.lineMetrics.slice(0, 4),
                                          function (metric) {
                                            return _c(
                                              "v-col",
                                              {
                                                key: metric.key,
                                                attrs: { cols: "6" },
                                              },
                                              [
                                                _c("h3", [
                                                  _vm._v(_vm._s(metric.name)),
                                                ]),
                                                _c("Plotly", {
                                                  attrs: {
                                                    data: _vm.getLineMetricData(
                                                      metric.key
                                                    ),
                                                    layout:
                                                      _vm.getLineMetricLayout(
                                                        metric.label
                                                      ),
                                                    config: {
                                                      responsive: true,
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                    _vm.lineMetrics.length > 4
                                      ? _c(
                                          "v-expansion-panels",
                                          { staticClass: "mt-4" },
                                          [
                                            _c(
                                              "v-expansion-panel",
                                              [
                                                _c("v-expansion-panel-header", [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Additional Line Charts (" +
                                                        _vm._s(
                                                          _vm.lineMetrics
                                                            .length - 4
                                                        ) +
                                                        " more)"
                                                    ),
                                                  ]),
                                                ]),
                                                _c(
                                                  "v-expansion-panel-content",
                                                  [
                                                    _c(
                                                      "v-row",
                                                      _vm._l(
                                                        _vm.lineMetrics.slice(
                                                          4
                                                        ),
                                                        function (metric) {
                                                          return _c(
                                                            "v-col",
                                                            {
                                                              key: metric.key,
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c("h3", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    metric.name
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("Plotly", {
                                                                attrs: {
                                                                  data: _vm.getLineMetricData(
                                                                    metric.key
                                                                  ),
                                                                  layout:
                                                                    _vm.getLineMetricLayout(
                                                                      metric.label
                                                                    ),
                                                                  config: {
                                                                    responsive: true,
                                                                  },
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.toolbarSettings.load.length > 0
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c("v-col", { attrs: { cols: "12" } }, [
                                          _c("h2", [_vm._v("Loads")]),
                                        ]),
                                        _vm._l(
                                          _vm.loadMetrics,
                                          function (metric) {
                                            return _c(
                                              "v-col",
                                              {
                                                key: metric.key,
                                                attrs: { cols: "6" },
                                              },
                                              [
                                                _c("h3", [
                                                  _vm._v(_vm._s(metric.name)),
                                                ]),
                                                _c("Plotly", {
                                                  attrs: {
                                                    data: _vm.getLoadMetricData(
                                                      metric.key
                                                    ),
                                                    layout:
                                                      _vm.getLoadMetricLayout(
                                                        metric.label
                                                      ),
                                                    config: {
                                                      responsive: true,
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.toolbarSettings.gen.length > 0
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c("v-col", { attrs: { cols: "12" } }, [
                                          _c("h2", [_vm._v("Generators")]),
                                        ]),
                                        _vm._l(
                                          _vm.genMetrics,
                                          function (metric) {
                                            return _c(
                                              "v-col",
                                              {
                                                key: metric.key,
                                                attrs: { cols: "6" },
                                              },
                                              [
                                                _c("h3", [
                                                  _vm._v(_vm._s(metric.name)),
                                                ]),
                                                _c("Plotly", {
                                                  attrs: {
                                                    data: _vm.getGenMetricData(
                                                      metric.key
                                                    ),
                                                    layout:
                                                      _vm.getGenMetricLayout(
                                                        metric.label
                                                      ),
                                                    config: {
                                                      responsive: true,
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.toolbarSettings.sgen.length > 0
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c("v-col", { attrs: { cols: "12" } }, [
                                          _c("h2", [
                                            _vm._v("Static Generators"),
                                          ]),
                                        ]),
                                        _vm._l(
                                          _vm.sgenMetrics,
                                          function (metric) {
                                            return _c(
                                              "v-col",
                                              {
                                                key: metric.key,
                                                attrs: { cols: "6" },
                                              },
                                              [
                                                _c("h3", [
                                                  _vm._v(_vm._s(metric.name)),
                                                ]),
                                                _c("Plotly", {
                                                  attrs: {
                                                    data: _vm.getSgenMetricData(
                                                      metric.key
                                                    ),
                                                    layout:
                                                      _vm.getSgenMetricLayout(
                                                        metric.label
                                                      ),
                                                    config: {
                                                      responsive: true,
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.toolbarSettings.trafo3w.length > 0
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "v-row",
                                      [
                                        _c("v-col", { attrs: { cols: "12" } }, [
                                          _c("h2", [
                                            _vm._v("3-Winding Transformers"),
                                          ]),
                                        ]),
                                        _vm._l(
                                          _vm.trafo3wMetrics.slice(0, 4),
                                          function (metric) {
                                            return _c(
                                              "v-col",
                                              {
                                                key: metric.key,
                                                attrs: { cols: "6" },
                                              },
                                              [
                                                _c("h3", [
                                                  _vm._v(_vm._s(metric.name)),
                                                ]),
                                                _c("Plotly", {
                                                  attrs: {
                                                    data: _vm.getTrafo3wMetricData(
                                                      metric.key
                                                    ),
                                                    layout:
                                                      _vm.getTrafo3wMetricLayout(
                                                        metric.label
                                                      ),
                                                    config: {
                                                      responsive: true,
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                    _vm.trafo3wMetrics.length > 4
                                      ? _c(
                                          "v-expansion-panels",
                                          { staticClass: "mt-4" },
                                          [
                                            _c(
                                              "v-expansion-panel",
                                              [
                                                _c("v-expansion-panel-header", [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Additional 3W Transformer Charts (" +
                                                        _vm._s(
                                                          _vm.trafo3wMetrics
                                                            .length - 4
                                                        ) +
                                                        " more)"
                                                    ),
                                                  ]),
                                                ]),
                                                _c(
                                                  "v-expansion-panel-content",
                                                  [
                                                    _c(
                                                      "v-row",
                                                      _vm._l(
                                                        _vm.trafo3wMetrics.slice(
                                                          4
                                                        ),
                                                        function (metric) {
                                                          return _c(
                                                            "v-col",
                                                            {
                                                              key: metric.key,
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c("h3", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    metric.name
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("Plotly", {
                                                                attrs: {
                                                                  data: _vm.getTrafo3wMetricData(
                                                                    metric.key
                                                                  ),
                                                                  layout:
                                                                    _vm.getTrafo3wMetricLayout(
                                                                      metric.label
                                                                    ),
                                                                  config: {
                                                                    responsive: true,
                                                                  },
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }